import { render, staticRenderFns } from "./AuthenticationModal.vue?vue&type=template&id=408b2e64&scoped=true"
import script from "./AuthenticationModal.vue?vue&type=script&lang=js"
export * from "./AuthenticationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b2e64",
  null
  
)

export default component.exports